import { Col, Progress, Spin } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import Button from '../../../../../../components/Button'
import Delete from '../../../../../../components/icons/Delete'
import confirmDelete from '../../../../../../components/icons/confirmDelete'

import { DocViewerRenderers, MSDocRenderer } from 'react-doc-viewer'
import ErrorMessage from 'utils/ErrorMessage'
import Control from '../../../../../../components/Control/Control'
import CloseRoleDrawer from '../../../../../../components/UIComponents/CloseRolePopup'
import SuccessIcon from '../../../../../../components/icons/SubmitCloseIcon'
import {
  AppTypography,
  ContinueManualBtn,
  EndColElement,
  HeaderComponent,
  ModalContainer,
  ModalContentContainer,
  PDFImageElement,
  ScrollableBox,
  SpaceBetweenRow,
  StyledDialog,
  StyledDocViewer,
} from '../../style'
import { handlePdfFile } from '../EligibiltyCriteria/CommonFunctions'
import DocumentDisplay from './DocumentDisplay'
import Uploader from './FileUpload'

export default function AutoJDFill({
  progress,
  parseLoading,
  setRoleFormData,
  setJdFile,
  jdFile,
  setDeleteRole,
  handleNextChange,
  setJdData,
  setProgress,
  roleFormData,
}) {
  const storedJdFile = localStorage.getItem('jdFile')
  const [file, setFile] = useState([])
  const [fileURL, setFileURL] = useState('')
  const [isPreviewOpen, setIsPreviewOpen] = useState(false)
  const [deleteWarning, setDeleteWarning] = useState(false)
  const [success, setSuccess] = useState(false)
  const [pdfImages, setPdfImages] = useState([])
  const uploadRef = useRef(null)

  useEffect(() => {
    if (jdFile?.length) {
      setFile(jdFile)
    } else {
      if (storedJdFile) {
        setJdFile(JSON.parse(storedJdFile))
        setFile(JSON.parse(storedJdFile))
      }
    }
  }, [])

  const renderHeader = () => {
    return (
      <HeaderComponent>
        <AppTypography>Viewing attachment</AppTypography>
        <DocumentDisplay spacing file={file} />
      </HeaderComponent>
    )
  }

  const renderDocument = () => {
    if (file.length === 0) return null

    switch (file[0]?.type) {
      case 'doc':
        return (
          <StyledDocViewer
            pluginRenderers={[MSDocRenderer]}
            documents={[
              {
                uri: file[0]?.url,
                fileType: 'doc',
                fileName: file[0]?.name,
              },
            ]}
          />
        )

      case 'pdf':
        return (
          <ScrollableBox type={'pdf'}>
            {pdfImages?.map((imageSrc, index) => (
              <PDFImageElement
                key={index}
                src={imageSrc}
                alt={`Page ${index + 1}`}
              />
            ))}
          </ScrollableBox>
        )

      default:
        return (
          <ScrollableBox>
            <StyledDocViewer
              documents={[
                {
                  uri: file[0]?.url,
                  fileType: 'docx',
                  fileName: file[0]?.name,
                },
              ]}
              pluginRenderers={DocViewerRenderers}
            />
          </ScrollableBox>
        )
    }
  }

  const handleFileChange = async newFile => {
    if (!newFile) return

    const fileObj = {
      name: newFile.name,
      url: URL.createObjectURL(newFile),
      type: newFile.type,
    }

    if (
      fileObj.type === 'pdf' ||
      fileObj.type === 'doc' ||
      fileObj.type === 'docx'
    ) {
      if (fileObj.type === 'pdf') {
        const images = await handlePdfFile(newFile)
        setPdfImages(images)
      }
    } else {
      setIsPreviewOpen(false)
      setFile([])
      return ErrorMessage('Invalid File Format')
    }

    setIsPreviewOpen(true)
  }

  const handleConfirmClick = () => {
    setIsPreviewOpen(false)
    setJdFile(file || [])
    setDeleteRole(true)
    setProgress(0)
    setRoleFormData(prev => ({
      ...prev,
      jdUrl: file || [],
    }))
  }

  const handleDisplayDocumentClick = () => {
    if (file[0]?.type == 'pdf') {
      window.open(file[0]?.url, '_blank').focus()
    } else {
      const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        file[0]?.url
      )}`
      window.open(officeViewerUrl, '_blank')
    }
  }

  const handleDeleteDocument = () => {
    setDeleteWarning(true)
  }

  const handleConfirmDelete = () => {
    setJdFile([])
    setFile([])
    setJdData({})
    setProgress(0)
    setDeleteRole(false)
    setRoleFormData(prev => ({
      ...prev,
      jdUrl: [],
      jdDetails: {},
    }))
    localStorage.removeItem('jdDetails')
    localStorage.removeItem('jdFile')
    handlePdfFile([])
    setDeleteWarning(false)
    setSuccess(true)
  }
  const handleCloseDeletePopup = () => {
    setSuccess(false)
  }

  return (
    <React.Fragment>
      <AppTypography level={5}>
        Let us automatically fill the Job Description for you!
      </AppTypography>
      {parseLoading ? (
        !progress || progress == 100 ? (
          <Spin center />
        ) : (
          <Control center>
            <Progress percent={progress} type="circle" />
          </Control>
        )
      ) : (
        <>
          <Uploader
            isDefault={true}
            file={file}
            setFile={setFile}
            setFileURL={setFileURL}
            fileURL={fileURL}
            format="(.doc, .pdf, .docx)"
            message={'Invalid file uploaded'}
            setIsPreviewJD={setIsPreviewOpen}
            isWhiteDesign
            customHeight={'170px'}
            handleFileChange={
              roleFormData?.status == 1 ? null : handleFileChange
            }
            ref={uploadRef}
            multiple={false}
            notAllowedCursor={roleFormData?.status == 1}
            pointerEventDisable={
              jdFile?.length > 0 || roleFormData?.status == 1
            }
            disabled={jdFile?.length > 0 || roleFormData?.status == 1}
          />
          {jdFile?.length > 0 ? (
            <SpaceBetweenRow>
              <Col md={22}>
                <DocumentDisplay
                  handleClick={handleDisplayDocumentClick}
                  showEyeIco
                  file={file}
                />
              </Col>
              <EndColElement
                md={2}
                onClick={
                  roleFormData?.status != 1 ? handleDeleteDocument : undefined
                }
              >
                <Delete />
              </EndColElement>
            </SpaceBetweenRow>
          ) : null}
          {deleteWarning && (
            <CloseRoleDrawer
              description={
                <>
                  Are you sure to delete <b>"{file[0].name}"</b>
                </>
              }
              Icon={confirmDelete}
              showDrawer={deleteWarning}
              setShowDrawer={setDeleteWarning}
              onApprove={handleConfirmDelete}
              onCloseClick={() => {
                setDeleteWarning(false)
              }}
              percentHeight={'13%'}
              percentWeight={'90%'}
            />
          )}
          {success && (
            <CloseRoleDrawer
              description={<>Deleted successfully</>}
              Icon={SuccessIcon}
              closeText={'Close'}
              showYes={false}
              showDrawer={success}
              setShowDrawer={setSuccess}
              onApprove={handleCloseDeletePopup}
              onCloseClick={() => setSuccess(false)}
            />
          )}

          <ContinueManualBtn
            text={'Continue Manually'}
            disable={jdFile?.length > 0}
            disabled={jdFile?.length > 0}
            onClick={handleNextChange}
          />
          <StyledDialog
            title=""
            closable={false}
            width={'1015px'}
            height="535px"
            style={{ height: '535px', borderRadius: '15px' }}
            open={isPreviewOpen}
            footer={false}
          >
            <ModalContainer>
              <div>{renderHeader()}</div>
              {file?.length > 0 ? (
                <ModalContentContainer>
                  {renderDocument()}
                </ModalContentContainer>
              ) : (
                <Spin
                  center
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '50vh',
                    width: '100vh',
                  }}
                />
              )}
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '2rem',
                  }}
                >
                  <Uploader
                    showButtonUpLoader
                    file={file}
                    setFile={setFile}
                    setFileURL={setFileURL}
                    fileURL={fileURL}
                    format="(.doc, .pdf, .docx)"
                    message={'Invalid file uploaded'}
                    setIsPreviewJD={setIsPreviewOpen}
                    isWhiteDesign
                    customHeight={'170px'}
                    handleFileChange={handleFileChange}
                    ref={uploadRef}
                    showButtonType={'secondary'}
                    multiple={false}
                  />
                  <Button.Primary
                    text="Looks good"
                    onClick={handleConfirmClick}
                    width="233px"
                  />
                </div>
              </div>
            </ModalContainer>
          </StyledDialog>
        </>
      )}
    </React.Fragment>
  )
}
